import {Colors} from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

import {TextArea} from '../../../Form/TextArea';
import {TextField} from '../../../Form/TextField';

export const CreateTriggerDrawer = styled.div`
  display: flex;
  width: 560px;
  height: 100%;
  flex-direction: column;
`;
CreateTriggerDrawer.displayName = 'S.CreateTriggerDrawer';

export const CreateTriggerDrawerMain = styled.div`
  flex: 1 1 auto;
  padding: 4px;
  padding-bottom: 300px;
  overflow-y: scroll;
`;
CreateTriggerDrawerMain.displayName = 'S.CreateTriggerDrawerMain';

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  padding: 20px 0px;
`;
Header.displayName = 'S.Header';

export const CloseButton = styled.div`
  text-align: right;
  flex: 1 1 auto;
`;
CloseButton.displayName = 'S.CloseButton';

export const PageLabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
  font-weight: 600;
  color: ${Colors.GRAY_500};
`;
PageLabelRow.displayName = 'S.PageLabelRow';

export const Description = styled.div`
  font-size: 16px;
  margin-bottom: 8px;
`;
Description.displayName = 'S.Description';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
Label.displayName = 'S.Label';

export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const Footer = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
`;
Footer.displayName = 'S.Footer';

export const FooterRightContent = styled.div`
  text-align: right;
  display: inline;
  min-width: 50px;
  flex: 1 0 50px;
  align-content: flex-end;
  vertical-align: middle;
`;
FooterRightContent.displayName = 'S.FooterRightContent';

export const FooterLeftContent = styled.div`
  text-align: right;
  display: inline;
  min-width: 50px;
  flex: 0 1 50px;
  align-content: flex-start;
  vertical-align: middle;
`;
FooterLeftContent.displayName = 'S.FooterLeftContent';

export const HelpMessage = styled.div`
  color: ${Colors.GRAY_600};
`;
HelpMessage.displayName = 'S.HelpMessage';

export const TemplateHelperRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 4px;
  justify-content: space-between;
  flex-wrap: wrap;
`;
TemplateHelperRow.displayName = 'S.TemplateHelperRow';

export const TemplateHelperKey = styled.div`
  flex: 1;
`;
TemplateHelperKey.displayName = 'S.TemplateHelperKey';

export const TemplateHelperString = styled.div`
  flex: 1;
  overflow: wrap;
`;
TemplateHelperString.displayName = 'S.TemplateHelperString';

export const SuccessfulQueue = styled.div`
  display: flex;
  align-items: center;
`;
SuccessfulQueue.displayName = 'S.SuccessfulQueue';

export const SuccessfulQueueMessage = styled.div`
  margin-left: 8px;
`;
SuccessfulQueueMessage.displayName = 'S.SuccessfulQueueMessage';

export const Error = styled.div`
  color: ${Colors.RED};
  font-size: 14px;
`;
Error.displayName = 'S.Error';

export const Divider = styled.div`
  background-color: ${Colors.GRAY_350};
  height: 1px;
  margin-left: -20px;
  margin-right: -20px;
`;

export const PlainText = styled.div`
  margin-top: 16px;
`;

export const StyledTextField = styled(TextField)`
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
StyledTextField.displayName = 'S.StyledTextField';

export const StyledTextArea = styled(TextArea)`
  min-height: 80px;
`;
StyledTextArea.displayName = 'S.StyledTextArea';
